import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export default function DrugNRx(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        id="Medical_Report"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        data-name="Medical Report"
        version="1.1"
      >
        <g transform="matrix(1,0,0,1,0,0)">
          <g fill="#6b71f2">
            <path
              d="m14 18h-10c-.4 0-.77-.24-.92-.62-.15-.37-.07-.8.22-1.09l13.99-14c.29-.29.72-.37 1.09-.22s.62.52.62.92v10c0 2.76-2.24 5-5 5zm-7.59-2h7.59c1.65 0 3-1.35 3-3v-7.59z"
              fill="#f00808"
              fill-opacity="1"
              data-original-color="#6b71f2ff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m26 36h-14c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1z"
              fill="#f00808"
              fill-opacity="1"
              data-original-color="#6b71f2ff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m26 44h-14c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1z"
              fill="#f00808"
              fill-opacity="1"
              data-original-color="#6b71f2ff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m26 52h-14c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1z"
              fill="#f00808"
              fill-opacity="1"
              data-original-color="#6b71f2ff"
              stroke="none"
              stroke-opacity="1"
            />
          </g>
          <path
            d="m33 62h-25c-2.76 0-5-2.24-5-5v-40c0-.27.11-.52.29-.71l14-14c.19-.19.44-.29.71-.29h24c2.76 0 5 2.24 5 5v21c0 .55-.45 1-1 1s-1-.45-1-1v-21c0-1.65-1.35-3-3-3h-23.59l-13.41 13.41v39.59c0 1.65 1.35 3 3 3h25c.55 0 1 .45 1 1s-.45 1-1 1z"
            fill="#0a0f26"
            fill-opacity="1"
            data-original-color="#0a0f26ff"
            stroke="none"
            stroke-opacity="1"
          />
          <path
            d="m42 30c-4.96 0-9 4.04-9 9v14c0 4.96 4.04 9 9 9 .55 0 1-.45 1-1s-.45-1-1-1c-3.86 0-7-3.14-7-7v-6h7c.55 0 1-.45 1-1s-.45-1-1-1h-7v-6c0-3.86 3.14-7 7-7s7 3.14 7 7v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-4.96-4.04-9-9-9z"
            fill="#0a0f26"
            fill-opacity="1"
            data-original-color="#0a0f26ff"
            stroke="none"
            stroke-opacity="1"
          />
          <path
            d="m58.36 46.64c-1.7-1.7-3.96-2.64-6.36-2.64s-4.66.94-6.36 2.64-2.64 3.96-2.64 6.36.94 4.66 2.64 6.36 3.96 2.64 6.36 2.64 4.66-.94 6.36-2.64 2.64-3.96 2.64-6.36-.94-4.66-2.64-6.36zm-11.31 11.31c-1.32-1.32-2.05-3.08-2.05-4.95 0-1.53.5-2.98 1.4-4.19l9.79 9.79c-1.2.9-2.66 1.4-4.19 1.4-1.87 0-3.63-.73-4.95-2.05zm10.55-.76-9.79-9.79c1.2-.9 2.66-1.4 4.19-1.4 1.87 0 3.63.73 4.95 2.05s2.05 3.08 2.05 4.95c0 1.53-.5 2.98-1.4 4.19z"
            fill="#f00808"
            fill-opacity="1"
            data-original-color="#6b71f2ff"
            stroke="none"
            stroke-opacity="1"
          />
          <path
            d="m38 28h-4c-.34 0-.67-.18-.85-.47l-4.15-6.64-4.15 6.64c-.17.27-.47.45-.79.47-.33.01-.64-.12-.84-.37l-3.22-4.02-3.22 4.02c-.19.24-.48.38-.78.38h-4c-.55 0-1-.45-1-1s.45-1 1-1h3.52l3.7-4.62c.38-.47 1.18-.47 1.56 0l3.12 3.9 4.25-6.8c.37-.58 1.33-.58 1.7 0l4.71 7.53h3.45c.55 0 1 .45 1 1s-.45 1-1 1z"
            fill="#0a0f26"
            fill-opacity="1"
            data-original-color="#0a0f26ff"
            stroke="none"
            stroke-opacity="1"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
